export default __webpack_public_path__ + "static/media/sunrise.0ceb4c8c.jpg";